import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { Reveal } from '../components/Reveal';
import { FAQS } from '../lib/site';
import { useSEO } from '../lib/seo';
import { CtaBanner } from '../sections/CtaBanner';

export const FaqPage = () => {
  useSEO({
    title: 'Frequently Asked Questions — CapableBee',
    description:
      'Everything you need to know about CapableBee — how the AI voice assistant works, lead capture, 24/7 availability, CRM integration, setup and more.',
  });

  return (
    <main className="pt-[72px]" data-testid="faq-page">
      <header className="relative overflow-hidden bg-gradient-to-b from-brand-ice via-brand-iceSoft to-white py-16 lg:py-20">
        <div className="bg-grid mask-fade-b pointer-events-none absolute inset-0" aria-hidden="true" />
        <div className="container-x relative mx-auto max-w-3xl text-center">
          <Reveal>
            <span className="inline-flex items-center gap-2 rounded-full border border-brand-lineBlue bg-white/80 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-brand-skyDeep shadow-card">
              <span className="h-1.5 w-1.5 rounded-full bg-brand-honey" aria-hidden="true" />
              FAQ
            </span>
          </Reveal>
          <Reveal delay={0.08}>
            <h1 className="mt-6 text-4xl font-extrabold tracking-tight text-brand-navy sm:text-5xl">
              Frequently Asked Questions
            </h1>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-brand-body/90 sm:text-lg">
              Everything you need to know about CapableBee.
            </p>
          </Reveal>
        </div>
      </header>

      <section className="pb-20">
        <div className="container-x mx-auto max-w-3xl">
          <Reveal>
            <Accordion type="single" collapsible className="space-y-4" data-testid="faq-page-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`faq-page-${i}`}
                  className="rounded-2xl border border-brand-line bg-white px-6 shadow-card"
                  data-testid={`faq-page-item-${i}`}
                >
                  <AccordionTrigger className="py-5 text-left text-base font-bold text-brand-navy hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 text-sm leading-relaxed text-slate-600">{f.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>

          <Reveal delay={0.1}>
            <div
              className="mt-10 rounded-3xl border border-brand-line bg-brand-iceSoft p-8 text-center"
              data-testid="faq-page-contact-card"
            >
              <p className="text-lg font-bold text-brand-navy">Still have questions?</p>
              <p className="mx-auto mt-2 max-w-md text-sm text-slate-600">
                Book a demo today and see how CapableBee can turn conversations into leads.
              </p>
              <Link
                to="/contact"
                data-testid="faq-page-contact-cta"
                className="mt-5 inline-flex items-center gap-2 rounded-full bg-brand-navy px-6 py-3 text-sm font-bold text-white transition-all hover:-translate-y-0.5 hover:shadow-lift"
              >
                Contact Us
                <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>

      <CtaBanner />
    </main>
  );
};
